module.exports = __webpack_public_path__ + "static/media/mathematics.c9b2283f.jpg";